import SnowmanRouter from './components/SnowmanRouter';
import './index.css';

const Snowman = () => {
  return (
    <div className='snowman-game'>
      <SnowmanRouter />
    </div>
  );
};

export default Snowman;
